<div class="tlr-breakdown-report-container">
    <div>
        <div *ngIf="!isDetailsBlock">
            <div class="tlr-breakdown-report-header report-header">
                <p class="section-title">TLR Break-Down by Section Report</p>
                <div class="exportToExcel excel-btn">
                    <button (click)="exportToExcel()" *ngIf="tabledataShow">Export To Excel</button>
                </div>
            </div>

            <div class="content-block">
                <div class="criterion-main-block">
                    <div class="tlr-breakdown-report-table">
                        <p-table [value]="tlrSectionData" [scrollable]="true" [paginator]="true" [rows]="10"
                            scrollHeight="400px" styleClass="breakdown-table">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th>Section</th>
                                    <th>Installed</th>
                                    <th>Engineered</th>
                                    <th>Beyond Due Date</th>
                                    <th>OTR</th>
                                    <th>OTR Overdue</th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-row>
                                <tr>
                                    <td>{{row.Section_Name}}</td>
                                    <td align="center">
                                        <a *ngIf="row.Installed > 0" class="Clickable"
                                            (click)="getDetails(row, 'I','Installed')">{{row.Installed}}</a>
                                        <span *ngIf="row.Installed == 0">{{row.Installed}}</span>
                                    </td>
                                    <td align="center">
                                        <a *ngIf="row.Engineered > 0" class="Clickable"
                                            (click)="getDetails(row, 'E','Engineered')">{{row.Engineered}}</a>
                                        <span *ngIf="row.Engineered == 0">{{row.Engineered}}</span>
                                    </td>
                                    <td align="center">
                                        <a *ngIf="row.Beyond_Due_Date > 0" class="Clickable"
                                            (click)="getDetails(row, 'B','Beyond Due Date')">{{row.Beyond_Due_Date}}</a>
                                        <span *ngIf="row.Beyond_Due_Date == 0">{{row.Beyond_Due_Date}}</span>
                                    </td>
                                    <td align="center">
                                        <a *ngIf="row.OTR > 0" class="Clickable"
                                            (click)="getDetails(row, 'O','OTR')">{{row.OTR}}</a>
                                        <span *ngIf="row.OTR == 0">{{row.OTR}}</span>
                                    </td>
                                    <td align="center">
                                        <a *ngIf="row.OTR_Overdue > 0" class="Clickable"
                                            (click)="getDetails(row, 'D','OTR Overdue')">{{row.OTR_Overdue}}</a>
                                        <span *ngIf="row.OTR_Overdue == 0">{{row.OTR_Overdue}}</span>
                                    </td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>
                </div>
                <div class="chart-block">
                    <h3 class="chart-title">TLR Break-Down by Section - {{currentDate | date:'M/d/yyyy'}}</h3>
                    <p-chart type="bar" [data]="chartData" [options]="chartOptions" [plugins]="plugins" class="chart"
                        (onDataSelect)="selectData($event)"></p-chart>
                </div>
            </div>
        </div>
        <div class="content-details-block" *ngIf="isDetailsBlock">
            <div class="report-header">
                <div>
                    <div class="section-title">TLR Break-Down by Section Report Details</div>
                    <div class="section-sub-title">
                        <span class="text-bold">{{sectionType}}</span>
                        &nbsp;
                        <span class="text-bold">Section:&nbsp; {{sectionTitle}}</span>
                    </div>
                </div>
                <div class="search-criteria">
                    <p-button styleClass="p-button-secondary" (click)="exportToExcel()"> Export to Excel</p-button>
                </div>
            </div>

            <div class="section-wrapper" style="max-height: none;">
                <p-table [value]="tlrReportDataDetails" [paginator]="true" [rows]="10" responsiveLayout="scroll"
                    width="50%">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Tag Number</th>
                            <th>Data Entry Date</th>
                            <th>Op. User ID</th>
                            <th>Division</th>
                            <th>Section</th>
                            <th>Plant</th>
                            <th>LDAR</th>
                            <th>Op. PSI</th>
                            <th>Op. Temp</th>
                            <th>Service</th>
                            <th>Insp User ID</th>
                            <th>Service Class</th>
                            <th>OA User ID</th>
                            <th>Permanent Repair Date</th>
                            <th>Eng. User ID</th>
                            <th>TLR Type</th>
                            <th>Maximo WO Number</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-item>
                        <tr>
                            <td>
                                <a class="Clickable"
                                    routerLink="/details-section/{{item.Tag_Number}}">{{item.Tag_Number}}</a>
                            </td>
                            <td>{{item.Data_Entry_Date | date : 'MM/dd/YYYY'}}</td>
                            <td>{{item.Operator_CAI}}</td>
                            <td>{{item.Division}}</td>
                            <td>{{item.Section}}</td>
                            <td>{{item.Plant}}</td>
                            <td>{{item.LDAR}}</td>
                            <td>{{item.Oper_PSI}}</td>
                            <td>{{item.Oper_Temp}}</td>
                            <td>{{item.Service}}</td>
                            <td>{{item.InspectionCAI}}</td>
                            <td>{{item.ServiceClass}}</td>
                            <td>{{item.OACAI}}</td>
                            <td [ngClass]="getDateClass(item.Permanent_Repair_Date)">{{item.Permanent_Repair_Date | date
                                :
                                'MM/dd/YYYY'}}</td>
                            <td>{{item.EngineeringCAI}}</td>
                            <td>{{item.TLRType}}</td>
                            <td>{{item.Maximo_WO_Number}}</td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="footer">
                        <tr class="total-sections-row">

                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
    </div>

</div>